@if (bontonPanel.isB2B()) {
<div class="flex flex-col flex-auto min-w-0 min-h-[calc(100vh-16rem)]">
  <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg -mt-20 shadow pb-5 relative"
    [class]="!wlSettingsDetails.is_wl ? 'pb-7' : ''">
    <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
      <div class="flex flex-col w-[25%] p-3 field-blue-bg rounded-lg max-h-16 cursor-pointer"
        (click)="openToCityDropdown()">
        <span class="text-gray text-md">Destination</span>
        <mat-select #destinationSelect class="font-semibold right-mat-select" formControlName="destination"
          [compareWith]="compareWith">
          <mat-select-trigger>
            {{ getCityName() }}
          </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search placeholderLabel="Search Destination"
              noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
            </ngx-mat-select-search>
          </mat-option>
          @for (ct of destinationList | async; track ct) {
          <mat-option [value]="ct">
            <div class="flex justify-center">
              @if (ct.type == 'City') {
              <mat-icon>location_on</mat-icon>
              }
              @if (ct.type == 'Hotel') {
              <mat-icon>apartment</mat-icon>
              }
              @if (ct.type == 'PointOfInterest') {
              <mat-icon>explore</mat-icon>
              }
              @if (ct.type == 'TrainStation') {
              <mat-icon>train</mat-icon>
              }
              @if (ct.type == 'Airport') {
              <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
              }
              @if (ct.type == 'MultiCity') {
              <mat-icon>location_city</mat-icon>
              }
              @if (ct.type == 'Region') {
              <mat-icon>public</mat-icon>
              }
              @if (ct.type == 'Neighborhood') {
              <mat-icon>near_me</mat-icon>
              }
              @if (ct.type == 'State') {
              <mat-icon>location_on</mat-icon>
              }
              <span class="font-normal text-base" [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
            </div>
          </mat-option>
          }
        </mat-select>
      </div>
      <div class="flex flex-col w-[20%] ml-[1%] field-blue-bg rounded-lg p-3 cursor-pointer" (click)="picker.open()">
        <span class="text-gray text-md">Check In</span>
        <div class="flex flex-row">
          <input matInput class="font-semibold" [min]="minDate" [readonly]="true" [matDatepicker]="picker"
            formControlName="checkin" (ngModelChange)="changeDate($event)" />
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div class="flex flex-col w-[20%] ml-[1%] field-blue-bg rounded-lg p-3 cursor-pointer" (click)="pickerOne.open()">
        <span class="text-gray text-md">Check Out</span>
        <div class="flex flex-row">
          <input matInput class="font-semibold" [min]="outmindate" [readonly]="true" [matDatepicker]="pickerOne"
            formControlName="checkout" />
        </div>
        <mat-datepicker #pickerOne></mat-datepicker>
      </div>
      <div class="w-[35%] ml-[1%] field-blue-bg rounded-lg cursor-pointer relative" #containerRef>
        <div class="flex flex-col p-3" (click)="openGuest()" #roomAndGuestRef>
          <span class="text-gray text-md">Rooms & Guests</span>
          <div class="flex flex-row">
            <span class="font-semibold">{{formGroup.get('room').value}} Room,
              {{formGroup.get('guest').value}} Guests</span>
          </div>
        </div>
        @if (selectedField === 'guest') {
        <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99 top-[70px]"
          #roomsAndGuestsDropdown>
          <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
            (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
        </div>
        }
      </div>
    </div>
    @if(!wlSettingsDetails.is_wl)
    {
    <div class="flex justify-end absolute right-4 bottom-2" (click)="helpVideo('Hotels')">
      <div class="flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer hover:bg-[#E8F1F8]">
        <span class="font-medium primary-text text-sm">NEED HELP?</span>
        <!-- <mat-icon class="icon-size-5 primary-text">play_circle</mat-icon> -->
        <mat-icon svgIcon="youtube" class="icon-size-5"></mat-icon>
      </div>
    </div>
    }
    <div class="flex flex-row justify-center items-center -mb-13 mt-2">
      <button mat-raised-button class="primary-bg w-50 min-h-13 rounded-lg" (click)="detail()">
        <span class="white-text font-semibold text-lg">Search</span>
      </button>
    </div>
  </form>
  @if (recentHotelSearchList?.length > 0) {
  <div class="flex flex-col mt-12">
    <div>
      <div class="text-2xl font-bold">Recent Hotel Search</div>
      <div class="text-sm text-gray">Compare your search history with starting price</div>
    </div>
    <div class="mt-1 flex flex-wrap">
      @for (rs of recentHotelSearchList; track rs) {
      <div
        class="white-bg flex rounded-lg p-3 shadow-[0_0_15px_0_rgba(167,167,167,0.2)] w-[32.33%] mx-[0.5%] mt-3 cursor-pointer"
        (click)="recentSearch(rs)">
        <div class="w-[80px] flex justify-center">
          <div class="field-blue-bg rounded-full w-[64px] h-[64px] flex items-center justify-center">
            <img loading="lazy" src="assets/images/icon/hotel-vector.svg" alt="hotel-vector" class="w-8 object-contain">
          </div>
        </div>
        <div class="w-[calc(100%-100px)] pl-1">
          <div class="font-semibold primary-text">{{rs.destination}}, {{rs.country}}</div>
          <div class="text-gray text-sm pt-1">In {{rs.checkin | date:'dd-MM-yyyy'}} - Out {{rs.checkout |
            date:'dd-MM-yyyy'}}</div>
          <div class="text-md">Room starting at <span class="font-semibold text-base">{{rs.currency}}
              {{rs.hotelRate}}</span></div>
        </div>
      </div>
      }
    </div>
  </div>
  }
  @if (PopularRecordsList?.finalInt.length > 0) {
  <div class="flex flex-col mt-12 space-y-3 mx-2">
    <div class="flex justify-between items-center pb-2">
      <div>
        <div class="text-2xl font-bold">Popular International Hotel</div>
        <div class="text-sm text-gray">Check out this popular stay that's getting more bookings than usual!
        </div>
      </div>
    </div>
    <div class="relative">
      <div>
        <ngx-slick-carousel class="carousel international_Hslick" #slickModal="slick-carousel" [config]="slideConfig">
          @for (at of PopularRecordsList?.finalInt; track at) {
          <div ngxSlickItem class="slide flex flex-col flex-grow cursor-pointer" (click)="popular(at)">
            <div class="flex items-center justify-center rounded-lg border border-gray-border white-bg overflow-hidden">
              <img loading="lazy"
                class="object-cover rounded-lg w-[230px] h-[250px]  transform transition duration-1000 hover:scale-125"
                [src]="at.image" />
            </div>
            <div class="flex pt-2 items-center">
              <div class="font-bold text-lg">{{at.destination}}</div>
            </div>
            <!-- <div class="text-gray text-sm mb-2">
                          {{'Starting at ' + at.currency + ' ' + at.hotelRate + ' Per person' }}
                        </div> -->
            <div class="mb-2">
              <span class="font-sans font-bold text-lg primary-text pt-1">{{at.currency }}
                {{at.hotelRate}} </span>
              <span class="font-sans font-normal text-base text-gray"> Onwards</span>
            </div>
          </div>
          }
        </ngx-slick-carousel>
      </div>
      @if (PopularRecordsList?.finalInt.length >= 6) {
      <div
        class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full left-0 top-[105px] -ml-6 shadow cursor-pointer"
        (click)="slickModal.slickPrev()">
        <mat-icon class="text-[#286494] relative left-1">arrow_back_ios</mat-icon>
      </div>
      }
      @if (PopularRecordsList?.finalInt.length >= 6) {
      <div
        class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full right-0 top-[105px] -mr-6 shadow cursor-pointer"
        (click)="slickModal.slickNext()">
        <mat-icon class="text-[#286494]">arrow_forward_ios</mat-icon>
      </div>
      }
    </div>
  </div>
  }
  @if (PopularRecordsList?.finalDom.length > 0) {
  <div class="flex flex-col mt-9 space-y-3 mx-2">
    <div class="flex justify-between items-center pb-2">
      <div>
        <div class="text-2xl font-bold">Popular Domestic Hotel</div>
        <div class="text-sm text-gray">Domestic popular stay that's getting more bookings than usual!</div>
      </div>
    </div>
    <div class="relative">
      <div>
        <ngx-slick-carousel class="carousel" #slickModall="slick-carousel" [config]="slideConfig1">
          @for (at of PopularRecordsList?.finalDom; track at) {
          <div ngxSlickItem class="slide flex flex-col flex-grow cursor-pointer" (click)="popular(at)">
            <div class="flex items-center justify-center rounded-lg border border-gray-border white-bg overflow-hidden">
              <img loading="lazy"
                class="object-cover rounded-lg w-[230px] h-[250px]  transform transition duration-1000 hover:scale-125"
                [src]="at.image" />
            </div>
            <div class="flex pt-2 items-center">
              <div class="font-bold text-lg">{{at.destination}}</div>
            </div>
            <div>
              <!-- {{'Starting at ' + at.currency + ' ' + at.hotelRate + ' Per person' }} -->
              <span class="font-sans font-bold text-lg primary-text pt-1">{{at.currency }}
                {{at.hotelRate}} </span>
              <span class="font-sans font-normal text-base text-gray"> Onwards</span>
            </div>
          </div>
          }
        </ngx-slick-carousel>
      </div>
      @if (PopularRecordsList?.finalDom.length >= 6) {
      <div
        class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full left-0 top-[105px] -ml-6 shadow cursor-pointer"
        (click)="slickModall.slickPrev()">
        <mat-icon class="text-[#286494] relative left-1">arrow_back_ios</mat-icon>
      </div>
      }
      @if (PopularRecordsList?.finalDom.length >= 6) {
      <div
        class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full right-0 top-[105px] -mr-6 shadow cursor-pointer"
        (click)="slickModall.slickNext()">
        <mat-icon class="text-[#286494]">arrow_forward_ios</mat-icon>
      </div>
      }
    </div>
  </div>
  }
  @if (settings?.data?.android_app_link || settings?.data?.ios_app_link) {
  <div class="bg-add mt-10 shadow rounded-xl h-[257px]">
    <div class="flex items-center justify-end h-full">
      <div class="flex flex-col gap-3 w-[710px] h-full justify-center">
        <p class="text-[18px] font-normal text-[#c6c6c6] max-w-[400px]">Get access to all Major Travel Services
          like Flights,
          Hotels, Bus, Holidays, and Visas at your Fingertips!</p>
        <div class="flex flex-row gap-3.5">
          @if (settings?.data?.ios_app_link) {
          <img loading="lazy" src="assets/images/image/app_store.webp" class="w-[150px] cursor-pointer" alt="app_store"
            (click)="openNewWindow(settings?.data?.ios_app_link)">
          }
          @if (settings?.data?.android_app_link) {
          <img loading="lazy" src="assets/images/image/google_play.webp" class="w-[170px] cursor-pointer"
            alt="google_play" (click)="openNewWindow(settings?.data?.android_app_link)">
          }
        </div>
      </div>
    </div>
  </div>
  }
  <div class="flex flex-col mb-7 space-y-3 mt-12">
    <span class="text-xl font-bold primary-text">Hotel Booking FAQ</span>
    <div class="flex flex-col space-y-1">
      <span class="font-semibold">Q. How can travel agencies benefit from using our B2B hotel booking
        platform?</span>
      <span class="text-gray">A. Explore the advantages and features that make our platform a valuable asset
        for travel agencies. Get exclusive deals, seamless booking processes, and tailored solutions for your
        business needs.</span>
    </div>
    <div class="flex flex-col space-y-1">
      <span class="font-semibold">Q. What sets our B2B hotel booking service apart in terms of customization for
        travel agencies?</span>
      <span class="text-gray">A. Discover how our platform caters to the specific requirements of travel
        agencies. From personalized booking options to flexible payment solutions, understand how we tailor our
        services to enhance the booking experience for your agency.</span>
    </div>
    <div class="flex flex-col space-y-1">
      <span class="font-semibold">Q. Are there special incentives or loyalty programs for frequent users on our
        B2B hotel booking platform?</span>
      <span class="text-gray">A. Learn about our rewards program designed to benefit loyal users. Find out
        how travel agencies can enjoy exclusive perks, discounts, or other incentives based on their booking
        frequency and volume through our platform.
      </span>
    </div>
    <div class="flex flex-col space-y-1">
      <span class="font-semibold">Q. How does our B2B hotel booking system ensure data security and
        confidentiality for travel agencies?</span>
      <span class="text-gray">A. Explore the robust security measures in place to protect sensitive
        information. Understand our commitment to safeguarding client data and maintaining confidentiality,
        reassuring travel agencies of a secure partnership.</span>
    </div>
    <div class="flex flex-col space-y-1">
      <span class="font-semibold">Q. Can travel agencies access real-time analytics and reporting features on our
        B2B hotel booking platform?</span>
      <span class="text-gray">A. Discover the analytical tools available to track booking trends, performance
        metrics, and other valuable insights. Understand how travel agencies can leverage this data to make
        informed decisions and optimize their hotel booking strategies.</span>
    </div>
  </div>
</div>
} @else {
<!--Theme 1-->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme1) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[21rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-3">
    <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-68px] relative z-[99]">
      <div class="m-auto rounded-[10px]">
        <form [formGroup]="formGroup" class="flex flex-col rounded-[10px]">
          <div class="flex flex-row w-full white-bg  rounded-[10px] shadow-xl relative">
            <div class="flex flex-row w-full">
              <div class="flex flex-col border-r gray-border pl-0 py-[25px] cursor-pointer"
                [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="destinationSelect.open()">
                <span class="font-normal text-[15px] ml-6 font-Roboto text-secondary">Destination</span>
                <mat-select (click)="selectedField = 'destination'"
                  class="ml-[22px] custom_dropdown_arrow pt-3 w-[273px] font-bold rounded-[5px] pr-[15px] pl-[15xp] text-xl"
                  formControlName="destination" [compareWith]="compareWith" #destinationSelect>
                  <mat-select-trigger>
                    {{ getCityName() }}
                  </mat-select-trigger>
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Destination"
                      noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (ct of destinationList | async; track ct) {
                  <mat-option [value]="ct">
                    <div class="flex justify-center truncate max-w-full">
                      @if (ct.type == 'City') {
                      <mat-icon>location_on</mat-icon>
                      }
                      @if (ct.type == 'Hotel') {
                      <mat-icon>apartment</mat-icon>
                      }
                      @if (ct.type == 'PointOfInterest') {
                      <mat-icon>explore</mat-icon>
                      }
                      @if (ct.type == 'TrainStation') {
                      <mat-icon>train</mat-icon>
                      }
                      @if (ct.type == 'Airport') {
                      <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                      }
                      @if (ct.type == 'MultiCity') {
                      <mat-icon>location_city</mat-icon>
                      }
                      @if (ct.type == 'Region') {
                      <mat-icon>public</mat-icon>
                      }
                      @if (ct.type == 'Neighborhood') {
                      <mat-icon>near_me</mat-icon>
                      }
                      @if (ct.type == 'State') {
                      <mat-icon>location_on</mat-icon>
                      }
                      <span class="font-normal text-base"
                        [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                    </div>
                    <!-- <div class="flex flex-col truncate max-w-full justify-center">
                                  <span class="font-normal text-base">{{ct.city}}
                                  </span>
                                </div> -->
                  </mat-option>
                  }
                </mat-select>
              </div>
              <div class="flex flex-col pl-[15px] w-[240px] border-r gray-border cursor-pointer"
                [ngClass]="selectedField == 'checkin' ? 'secondary-bg' : ''" (click)="picker2.open()">
                <div class="ml-[7px] py-[25px]">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Check In</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="picker2" [min]="minDate" (click)="picker2.open();selectedField = 'checkin'"
                    formControlName="checkin" (ngModelChange)="changeDate($event)">
                  <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </div>
              </div>
              <div class="flex flex-col pl-[15px] w-[240px] border-r gray-border cursor-pointer"
                [ngClass]="selectedField == 'checkout' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
                <div class="ml-[7px] py-[25px]">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Check Out</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="pickerOne" [min]="outmindate" (click)="pickerOne.open();selectedField = 'checkout'"
                    formControlName="checkout">
                  <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOne></mat-datepicker>
                </div>
              </div>
              <div class="" #containerRef>
                <div class="min-w-[300px] flex flex-col pt-[28px] pb-[29px] pl-4 border-r gray-border cursor-pointer"
                  [ngClass]="selectedField == 'guest' ? 'secondary-bg' : ''" (click)="openGuest()" #roomAndGuestRef>
                  <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Guest</span>
                  <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-[8px] cursor-pointer">
                    {{formGroup.get('room').value}} Room(s), {{formGroup.get('guest').value}}
                    Guest(s)
                  </div>
                </div>
                @if (selectedField === 'guest') {
                <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99"
                  #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[122px]':'top-[122px]'">
                  <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                    (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
                </div>
                }
              </div>
              <div class="w-full h-full justify-end pr-5 flex items-center">
                <button class="primary-bg rounded-lg py-10 px-12" mat-flat-button (click)="detail()">
                  <span class="white-text font-semibold text-2xl font-Roboto">Search</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 2 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme2) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
        background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[16.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] mt-[-110px] rounded-[15px]">
    <div class="mr-6 rounded-[15px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-6 white-bg rounded-[15px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[28%] max-w-[28%] h-[60px] border-2 pt-0 pb-3 pl-3 pr-3 rounded-lg cursor-pointer"
            [ngClass]="selectedField == 'destination' ? 'primary-border' : 'gray-border'"
            (click)="destinationSelect.open()">
            <span class="text-[15px] mt-[-11px] font-Roboto white-bg px-[10px] max-w-max font-medium"
              [ngClass]="selectedField == 'destination' ? 'primary-text' : 'text-secondary'">Destination</span>
            <mat-select (click)="selectedField = 'destination'"
              class="mt-1 pl-2 font-bold font-Roboto text-2xl theme-black-text" [compareWith]="compareWith"
              formControlName="destination" #destinationSelect>
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                <span class="font-normal text-base">{{ct.city}}
                                </span>
                              </div> -->
              </mat-option>
              }
            </mat-select>
          </div>
          <div [ngClass]="selectedField == 'checkin' ? 'primary-border' : 'gray-border'"
            class="flex flex-col w-[30%] h-[60px] white-bg rounded-lg pb-3 pr-3 border-2 cursor-pointer"
            (click)="picker.open()">
            <span class="text-[15px] mt-[-11px] ml-2 font-Roboto white-bg px-[5px] max-w-max font-medium"
              [ngClass]="selectedField == 'checkin' ? 'primary-text' : 'text-secondary'">Check
              In</span>
            <div class="flex flex-row pl-3">
              <input class="font-bold text-2xl font-Roboto max-w-[9rem] theme-black-text mt-1" [min]="minDate"
                (click)="picker.open(); selectedField = 'checkin'" [readonly]="true"
                (ngModelChange)="changeDate($event)" [matDatepicker]="picker" formControlName="checkin" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div [ngClass]="selectedField == 'checkout' ? 'primary-border' : 'gray-border'"
            class="flex flex-col w-[30%] h-[60px] white-bg rounded-lg pb-3 pr-3 border-2 cursor-pointer"
            (click)="pickerOne.open()">
            <span class="text-[15px] mt-[-11px] ml-2 font-Roboto white-bg px-[5px] max-w-max font-medium"
              [ngClass]="selectedField == 'checkout' ? 'primary-text' : 'text-secondary'">Check
              Out</span>
            <div class="flex flex-row pl-3">
              <input class="font-bold text-2xl font-Roboto max-w-[9rem] theme-black-text mt-1" [min]="outmindate"
                (click)="pickerOne.open(); selectedField = 'checkout'" [readonly]="true" [matDatepicker]="pickerOne"
                formControlName="checkout" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
          </div>
          <div class="min-w-[24%] max-w-[24%] relative" #containerRef>
            <div class="flex flex-col flex-grow p-3 pl-0  white-bg rounded-lg border-2 h-[60px] cursor-pointer "
              [ngClass]="selectedField == 'roomsguests' ? 'primary-border' : 'gray-border'" (click)="openGuest()"
              #roomAndGuestRef>
              <span [ngClass]="selectedField == 'roomsguests' ? 'primary-text' : 'text-secondary'"
                class="font-Roboto white-bg ml-2 px-[5px] max-w-max font-medium text-[15px] mt-[-23px]">Rooms
                & Guests</span>
              <span class="font-bold pl-3 text-2xl font-Roboto theme-black-text pt-1">{{formGroup.get('room').value}}
                Room,
                {{formGroup.get('guest').value}} Guests</span>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99 right-0"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[73px]':'top-[66px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center mb-[-45px] space-x-4">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-semibold text-2xl font-Inter">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 3 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme3) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[18.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-75px]">
    <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[28%] max-w-[28%] h-[74px] py-3 px-2 secondary-bg rounded-lg cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 px-2 font-semibold text-xl" #destinationSelect formControlName="destination"
              [compareWith]="compareWith">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                  <span class="font-normal text-base">{{ct.city}}
                                  </span>
                                </div> -->
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[30%] h-[74px] secondary-bg rounded-lg px-3 py-2.5 cursor-pointer"
            (click)="picker.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Check In</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[120px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                (ngModelChange)="changeDate($event)" />
              <mat-icon svgIcon="mat_outline:date_range" class="primary-text mt-1 cursor-pointer"
                (click)="picker.open()"></mat-icon>
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[30%] h-[74px] secondary-bg rounded-lg px-3 py-2.5 cursor-pointer"
            (click)="pickerOne.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Check Out</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[120px]" [min]="outmindate" (click)="pickerOne.open()"
                [readonly]="true" [matDatepicker]="pickerOne" formControlName="checkout" />
              <mat-icon svgIcon="mat_outline:date_range" class="primary-text mt-1 cursor-pointer"
                (click)="pickerOne.open()"></mat-icon>
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
          </div>
          <div class="min-w-[24%] max-w-[24%] relative" #containerRef>
            <div class="flex flex-col h-[74px] py-3 px-2 secondary-bg rounded-lg cursor-pointer" (click)="openGuest()"
              #roomAndGuestRef>
              <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Rooms
                & Guests</span>
              <span class="pl-2 font-semibold text-xl mt-1 cursor-pointer">{{formGroup.get('room').value}}
                Room,
                {{formGroup.get('guest').value}} Guests</span>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99 right-0"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-11 space-x-4">
          <button mat-flat-button class="w-50 min-h-13 rounded-lg primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 4 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme4) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-95px]">
    <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[22px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[28%] max-w-[28%] h-[74px] py-3 pr-2 pl-[17px] cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg pr-[8px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 pr-2 font-semibold text-xl" formControlName="destination" #destinationSelect
              [compareWith]="compareWith">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                    <span class="font-normal text-base">{{ct.city}}
                                    </span>
                                  </div> -->
              </mat-option>
              }
            </mat-select>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[30%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="picker.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Check In</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[140px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                (ngModelChange)="changeDate($event)" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[30%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="pickerOne.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Check Out</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[140px]" [min]="outmindate" (click)="pickerOne.open()"
                [readonly]="true" [matDatepicker]="pickerOne" formControlName="checkout" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="min-w-[24%] max-w-[24%] relative" #containerRef>
            <div class="flex flex-col flex-grow px-3 justify-end pt-2.5 h-[74px] cursor-pointer" (click)="openGuest()"
              #roomAndGuestRef>
              <span class="max-w-max text-secondary text-lg font-normal pb-1">Rooms & Guests</span>
              <span class="font-semibold text-xl cursor-pointer">{{formGroup.get('room').value}} Room,
                {{formGroup.get('guest').value}} Guests</span>
              <div class="gray-border mt-[3px] w-full mb-1 border-t-2"></div>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99 right-0"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[47px] space-x-4">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 5 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme5) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-row bg-center justify-center items-center bg-no-repeat h-[540px] primary-bg w-full"
    style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
background-color: #000000b3 !important;">
    <div class="flex flex-row gap-6 min-w-[1260px] max-w-[1260px] h-full">
      <div class="flex flex-col h-full items-center justify-center w-1/2">
        <div class="flex flex-col gap-[2px]">
          <div class="flex">
            <h1
              class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
              {{hotelData?.title}}</h1>
          </div>
          <div class="flex text-base justify-center font-Inter white-text">
            <div class="text-center w-[500px] z-[99] textNote4 font-normal gray-text">
              {{hotelData?.description}}</div>
          </div>
        </div>
      </div>
      <div class="w-1/2 h-full flex flex-col">
        <form [formGroup]="formGroup" class="flex flex-col h-full w-full justify-center gap-3 theme5-form-field">
          <div class="flex flex-col white-bg rounded-lg shadow-xl p-5 w-full gap-5">
            <mat-form-field class="w-full cursor-pointer">
              <mat-label class="text-secondary text-base font-normal">Destination</mat-label>
              <mat-select class="font-medium text-[15px] text-black pr-1 max-w-[523px]" [compareWith]="compareWith"
                formControlName="destination">
                <mat-select-trigger>
                  {{ getCityName() }}
                </mat-select-trigger>
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter"
                    (input)="searchDestinationText = $event.target.value">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationList | async; track ct) {
                <mat-option [value]="ct">
                  <div class="flex justify-center truncate max-w-full">
                    @if (ct.type == 'City') {
                    <mat-icon>location_on</mat-icon>
                    }
                    @if (ct.type == 'Hotel') {
                    <mat-icon>apartment</mat-icon>
                    }
                    @if (ct.type == 'PointOfInterest') {
                    <mat-icon>explore</mat-icon>
                    }
                    @if (ct.type == 'TrainStation') {
                    <mat-icon>train</mat-icon>
                    }
                    @if (ct.type == 'Airport') {
                    <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                    }
                    @if (ct.type == 'MultiCity') {
                    <mat-icon>location_city</mat-icon>
                    }
                    @if (ct.type == 'Region') {
                    <mat-icon>public</mat-icon>
                    }
                    @if (ct.type == 'Neighborhood') {
                    <mat-icon>near_me</mat-icon>
                    }
                    @if (ct.type == 'State') {
                    <mat-icon>location_on</mat-icon>
                    }
                    <span class="font-normal text-base"
                      [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                  </div>
                  <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                        <span class="font-normal text-base"
                                        [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                                      </div> -->
                </mat-option>
                }
              </mat-select>
              <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
            </mat-form-field>
            <div class="flex flex-row gap-3 w-full">
              <mat-form-field class="w-1/2 cursor-pointer">
                <mat-label class="text-secondary text-base font-normal">Check In</mat-label>
                <input matInput class="font-medium text-[15px] text-black" [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                  (ngModelChange)="changeDate($event)" />
                <mat-datepicker #picker></mat-datepicker>
                <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker.open()"></mat-icon>
              </mat-form-field>
              <mat-form-field class="w-1/2 cursor-pointer">
                <mat-label class="text-secondary text-base font-normal">Check Out</mat-label>
                <input matInput class="font-medium text-[15px] text-black" [min]="outmindate" (click)="picker2.open()"
                  [readonly]="true" [matDatepicker]="picker2" formControlName="checkout" />
                <mat-datepicker #picker2></mat-datepicker>
                <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker2.open()"></mat-icon>
              </mat-form-field>
            </div>
            <div class="flex flex-row gap-3 relative" #containerRef>
              <div class="flex flex-col w-1/2 h-[74px] cursor-pointer" (click)="openGuest()" #roomAndGuestRef>
                <span class="text-secondary text-base font-normal pb-[6px] leading-5">Rooms &
                  Guests</span>
                <span
                  class="font-medium text-[15px] text-black cursor-pointer rounded-md border-[1px] py-[12px] px-4 flex flex-row justify-between"
                  [ngClass]="isOpenRoomsGuests ? 'border-[#4f46e5]' :'border-[#737373]'">{{formGroup.get('room').value}}
                  Room,
                  {{formGroup.get('guest').value}} Guests
                  <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                </span>
              </div>
              @if (selectedField === 'guest') {
              <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99" #roomsAndGuestsDropdown
                [ngClass]="guestPopAbove?'bottom-[80px]':'top-[80px]'">
                <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
              </div>
              }
            </div>
            <div class="flex justify-center items-center py-1">
              <button mat-flat-button class="w-full py-[26px] rounded-lg primary-bg" (click)="detail()">
                <span class="white-text font-medium text-[17px]">Search</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 6-->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme6) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[18rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pt-3">
    <div class="min-w-[1260px] max-w-[1260px] m-auto mt-[-62px] relative z-[99]">
      <div class="m-auto rounded-[10px]">
        <form [formGroup]="formGroup" class="flex flex-col rounded-[10px]">
          <div class="flex flex-row w-full white-bg h-[100px] rounded-[65px] shadow-xl">
            <div class="flex flex-row w-full">
              <div class="flex flex-col border-r gray-border justify-center pl-13 cursor-pointer"
                [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="destinationSelect.open()">
                <span class="font-normal text-[15px] font-Roboto text-secondary">Destination</span>
                <mat-select (click)="selectedField = 'destination'" #destinationSelect
                  class="custom_dropdown_arrow pt-1 w-[300px] font-bold rounded-[5px] pr-[15px] pl-[15xp] text-xl"
                  formControlName="destination" [compareWith]="compareWith">
                  <mat-select-trigger>
                    {{ getCityName() }}
                  </mat-select-trigger>
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Destination"
                      noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (ct of destinationList | async; track ct) {
                  <mat-option [value]="ct">
                    <div class="flex justify-center truncate max-w-full">
                      @if (ct.type == 'City') {
                      <mat-icon>location_on</mat-icon>
                      }
                      @if (ct.type == 'Hotel') {
                      <mat-icon>apartment</mat-icon>
                      }
                      @if (ct.type == 'PointOfInterest') {
                      <mat-icon>explore</mat-icon>
                      }
                      @if (ct.type == 'TrainStation') {
                      <mat-icon>train</mat-icon>
                      }
                      @if (ct.type == 'Airport') {
                      <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                      }
                      @if (ct.type == 'MultiCity') {
                      <mat-icon>location_city</mat-icon>
                      }
                      @if (ct.type == 'Region') {
                      <mat-icon>public</mat-icon>
                      }
                      @if (ct.type == 'Neighborhood') {
                      <mat-icon>near_me</mat-icon>
                      }
                      @if (ct.type == 'State') {
                      <mat-icon>location_on</mat-icon>
                      }
                      <span class="font-normal text-base"
                        [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                    </div>
                    <!-- <div class="flex flex-col truncate max-w-full justify-center">
                                            <span class="font-normal text-base">{{ct.city}}
                                            </span>
                                          </div> -->
                  </mat-option>
                  }
                </mat-select>
              </div>
              <div class="flex flex-col pl-[11px] w-full border-r gray-border justify-center cursor-pointer"
                [ngClass]="selectedField == 'checkin' ? 'secondary-bg' : ''" (click)="picker2.open()">
                <div class="">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Check In</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="picker2" [min]="minDate" (click)="picker2.open();selectedField = 'checkin'"
                    formControlName="checkin" (ngModelChange)="changeDate($event)">
                  <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </div>
              </div>
              <div class="flex flex-col pl-[11px] w-full border-r gray-border justify-center cursor-pointer"
                [ngClass]="selectedField == 'checkout' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
                <div class="">
                  <mat-label class="white-text text-[15px] items-center gap-1 flex">
                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                        alt="date_icon"></span>
                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Check Out</span>
                  </mat-label>
                  <input readonly class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[135px]" matInput
                    [matDatepicker]="pickerOne" [min]="outmindate" (click)="pickerOne.open();selectedField = 'checkout'"
                    formControlName="checkout">
                  <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOne></mat-datepicker>
                </div>
              </div>
              <div class="min-w-[300px] cursor-pointer pl-2.5 relative flex items-center border-r gray-border"
                [ngClass]="selectedField == 'guest' ? 'secondary-bg' : ''" #containerRef>
                <div class=" flex flex-col justify-center " (click)="openGuest()" #roomAndGuestRef>
                  <span class="text-[15px] rounded-lg w-full h-[24px] text-secondary">Guest</span>
                  <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-0.5 cursor-pointer">
                    {{formGroup.get('room').value}} Room(s), {{formGroup.get('guest').value}}
                    Guest(s)
                  </div>
                </div>
                @if (selectedField === 'guest') {
                <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99"
                  #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[105px]':'top-[105px]'">
                  <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                    class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
                </div>
                }
              </div>
              <div class="w-full h-full justify-end pr-5 flex items-center">
                <button class="primary-bg rounded-full py-8 px-13" mat-flat-button (click)="detail()">
                  <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 7 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme7) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[635px]">
  <div class="absolute top-[-73px] w-full h-[710px] z-10"
    [style]="'background-image: url('+hotelData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem] mt-[73px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[52px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
    <div class="mr-6 rounded-b-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col p-5 pb-1.5 pt-2 white-bg rounded-b-xl shadow-xl theme7-form-field">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <mat-form-field class="min-w-[25%] max-w-[25%]">
            <mat-label class="text-secondary text-lg font-normal cursor-pointer">Destination</mat-label>
            <mat-select class="font-medium text-[17px] h-[60px]" [compareWith]="compareWith"
              formControlName="destination">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                          <span class="font-normal text-base">
                                          {{ct.city}}</span>
                                        </div> -->
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-[15%] min-w-[15%]">
            <mat-label class="text-secondary text-lg font-normal cursor-pointer">Check In</mat-label>
            <input matInput class="font-medium text-[17px] h-[60px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
              (ngModelChange)="changeDate($event)" />
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="w-[15%] min-w-[15%]">
            <mat-label class="text-secondary text-lg font-normal cursor-pointer">Check Out</mat-label>
            <input matInput class="font-medium text-[17px] h-[60px]" [min]="outmindate" (click)="picker2.open()"
              [readonly]="true" [matDatepicker]="picker2" formControlName="checkout" />
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <div class="w-full" #containerRef>
            <div class="flex flex-col w-full" (click)="openGuest()" #roomAndGuestRef>
              <span class="text-secondary text-lg font-normal pb-[3px] leading-[21px]">Rooms &
                Guests</span>
              <span
                class="font-medium text-[17px] cursor-pointer rounded-[10px] border-[1px] pt-[18px] pb-[17px] px-4 flex flex-row justify-between"
                [ngClass]="isOpenRoomsGuests ? 'border-[#4f46e5]' :'border-[#c2c2c799]'">{{formGroup.get('room').value}}
                Room,
                {{formGroup.get('guest').value}} Guests
              </span>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute round-shadow z-99" #roomsAndGuestsDropdown
              [ngClass]="guestPopAbove?'bottom-[245px]':'top-[487px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
          <div class="flex justify-center items-end pl-1">
            <button mat-flat-button class="w-36 min-h-[65px] rounded-lg primary-bg" (click)="detail()">
              <span class="white-text font-medium text-2xl">Search</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 8 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme8) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[575px]">
  <div class="absolute top-[-73px] w-full h-[650px] z-10"
    [style]="'background-image: url('+hotelData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem] mt-[120px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[41px] justify-center font-normal leading-[65px] white-text flex w-full z-[99]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-100px]">
    <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col rounded-2xl bg-[#0a0707ab] border light-border px-5 py-6">
        <div class="flex flex-row w-full rounded-[5px] white-bg">
          <div class="flex flex-row w-full">
            <div class="flex flex-col justify-center border-r gray-border cursor-pointer text-black"
              [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''" (click)="destinationSelect.open()">
              <span class="font-normal text-[15px] ml-6 font-Roboto text-secondary">Destination</span>
              <mat-select (click)="selectedField = 'destination'" #destinationSelect
                class="ml-[22px] custom_dropdown_arrow pt-1 w-[273px] rounded-[5px] pr-[15px] pl-[15xp] font-Roboto font-medium text-xl"
                formControlName="destination" [compareWith]="compareWith">
                <mat-select-trigger>
                  {{ getCityName() }}
                </mat-select-trigger>
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationList | async; track ct) {
                <mat-option [value]="ct">
                  <div class="flex justify-center truncate max-w-full">
                    @if (ct.type == 'City') {
                    <mat-icon>location_on</mat-icon>
                    }
                    @if (ct.type == 'Hotel') {
                    <mat-icon>apartment</mat-icon>
                    }
                    @if (ct.type == 'PointOfInterest') {
                    <mat-icon>explore</mat-icon>
                    }
                    @if (ct.type == 'TrainStation') {
                    <mat-icon>train</mat-icon>
                    }
                    @if (ct.type == 'Airport') {
                    <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                    }
                    @if (ct.type == 'MultiCity') {
                    <mat-icon>location_city</mat-icon>
                    }
                    @if (ct.type == 'Region') {
                    <mat-icon>public</mat-icon>
                    }
                    @if (ct.type == 'Neighborhood') {
                    <mat-icon>near_me</mat-icon>
                    }
                    @if (ct.type == 'State') {
                    <mat-icon>location_on</mat-icon>
                    }
                    <span class="font-normal text-base"
                      [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                  </div>
                  <!-- <div class="flex flex-col truncate max-w-full justify-center">
                                              <span class="font-normal text-base">{{ct.city}}
                                              </span>
                                            </div> -->
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[240px] border-r gray-border h-[75px] cursor-pointer"
              [ngClass]="selectedField == 'checkin' ? 'secondary-bg' : ''" (click)="picker2.open()">
              <div class="ml-[7px]">
                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Check
                    In</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="picker2" [min]="minDate" (click)="picker2.open();selectedField = 'checkin'"
                  formControlName="checkin" (ngModelChange)="changeDate($event)">
                <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[220px] border-r gray-border cursor-pointer"
              [ngClass]="selectedField == 'checkout' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
              <div class="ml-[7px]">
                <mat-label class="items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Check
                    Out</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="pickerOne" [min]="outmindate" (click)="pickerOne.open();selectedField = 'checkout'"
                  formControlName="checkout">
                <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #pickerOne></mat-datepicker>
              </div>
            </div>
            <div class="min-w-[300px] pl-4 border-r gray-border cursor-pointer flex items-center relative"
              [ngClass]="selectedField == 'guest' ? 'secondary-bg' : ''" #containerRef>
              <div class="flex flex-col justify-center" (click)="openGuest()" #roomAndGuestRef>
                <span class="font-Roboto text-[15px] text-secondary font-normal w-full h-[24px]">Guest</span>
                <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer">
                  {{formGroup.get('room').value}} Room(s), {{formGroup.get('guest').value}}
                  Guest(s)
                </div>
              </div>
              @if (selectedField === 'guest') {
              <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute left-0 round-shadow z-99"
                #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[80px]':'top-[80px]'">
                <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
              </div>
              }
            </div>
            <div class="h-[75px] w-[192px] min-w-[192px] min-h-[75px] justify-end flex items-center">
              <button class="primary-bg rounded-none h-[75px] min-h-[75px] w-full rounded-r-[5px]" mat-flat-button
                (click)="detail()">
                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 9 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme9) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden h-[635px]">
  <div class="absolute top-[-73px] w-full h-[600px] z-10"
    [style]="'background-image: url('+hotelData?.background_image+');background-blend-mode: color !important; background-color: #000000bd !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[352px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[46px] justify-center font-semibold white-text flex w-full z-[99]">
            {{hotelData?.title}}
          </h1>
        </div>
        <div class="flex text-xl justify-center font-normal font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px]">
    <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-[6px] white-bg rounded-[12px] shadow-xl pb-5">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div class="flex flex-col min-w-[30%] max-w-[30%] h-[74px] py-3 pr-2 pl-[17px] cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg pr-[8px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 pr-2 font-medium text-xl" formControlName="destination" #destinationSelect
              [compareWith]="compareWith">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                              <span class="font-normal text-base">{{ct.city}}
                                              </span>
                                            </div> -->
              </mat-option>
              }
            </mat-select>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="picker.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Check In</span>
            <div class="flex flex-row">
              <input class="font-medium text-xl mt-1 max-w-[140px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                (ngModelChange)="changeDate($event)" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] px-3 py-2.5 cursor-pointer" (click)="pickerOne.open()">
            <span class="max-w-max text-secondary text-lg font-normal">Check Out</span>
            <div class="flex flex-row">
              <input class="font-medium text-xl mt-1 max-w-[140px]" [min]="outmindate" (click)="pickerOne.open()"
                [readonly]="true" [matDatepicker]="pickerOne" formControlName="checkout" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
            <div class="gray-border mt-[3px] w-full border-t-2"></div>
          </div>
          <div class="min-w-[30%] max-w-[20%] cursor-pointer relative" #containerRef>
            <div class="flex flex-col flex-grow px-3 justify-end pt-2.5 h-[74px]" (click)="openGuest()"
              #roomAndGuestRef>
              <span class="max-w-max text-secondary text-lg font-normal pb-1">Rooms & Guests</span>
              <span class="font-medium text-xl cursor-pointer">{{formGroup.get('room').value}} Room,
                {{formGroup.get('guest').value}} Guests</span>
              <div class="gray-border mt-[3px] w-full mb-1 border-t-2"></div>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute left-0 round-shadow z-99"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[42px] space-x-4 rounded-r-md">
          <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 10 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme10) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden relative">
  <div class="absolute top-0 w-full h-[375px] flex flex-row items-end">
    <div class="w-full min-h-full h-full relative">
      <div style="background-image: url(assets/images/b2c/theme_10_header_img.svg);
                background-repeat: no-repeat;
                background-position: right;
                background-size: cover;" class="z-10 min-h-full h-full w-[55%] absolute top-0 left-0"></div>
      <img loading="lazy" [src]="hotelData?.background_image" alt="bg-img"
        class="object-cover bg-left h-full w-1/2 absolute top-0 right-0">
    </div>
  </div>
  <div class="flex flex-col bg-no-repeat h-[375px] bg-[#F9F9F9] w-full gray-text">
    <div class="flex flex-col min-w-[1260px] max-w-[1260px] m-auto h-full items-center justify-center">
      <div class="flex flex-col w-full">
        <div class="flex">
          <h1 class="text-[52px] justify-start font-bold font-Dosis theme-black-text flex w-[50%] z-[99] pr-2">
            {{hotelData?.title}}
          </h1>
        </div>
        <div class="flex text-xl justify-start font-Ibm_Plex_Sans_Devanagari theme-black-text w-[50%] pr-2">
          <div class="w-full z-[99] textNote4">
            {{hotelData?.description}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-40px]">
    <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-row white-bg rounded-[5px] shadow-xl">
        <div class="flex flex-row w-full  rounded-[5px] white-bg">
          <div class="flex flex-row w-full">
            <div class="flex flex-col justify-center border-r gray-border cursor-pointer"
              (click)="destinationSelect.open()" [ngClass]="selectedField == 'destination' ? 'secondary-bg' : ''">
              <span class="font-normal text-[15px] ml-6 font-Roboto text-secondary">Destination</span>
              <mat-select (click)="selectedField = 'destination'" #destinationSelect
                class="ml-[22px] custom_dropdown_arrow pt-1 w-[273px] rounded-[5px] pr-[15px] pl-[15xp] font-Roboto font-medium text-xl"
                formControlName="destination" [compareWith]="compareWith">
                <mat-select-trigger>
                  {{ getCityName() }}
                </mat-select-trigger>
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationList | async; track ct) {
                <mat-option [value]="ct">
                  <div class="flex justify-center truncate max-w-full">
                    @if (ct.type == 'City') {
                    <mat-icon>location_on</mat-icon>
                    }
                    @if (ct.type == 'Hotel') {
                    <mat-icon>apartment</mat-icon>
                    }
                    @if (ct.type == 'PointOfInterest') {
                    <mat-icon>explore</mat-icon>
                    }
                    @if (ct.type == 'TrainStation') {
                    <mat-icon>train</mat-icon>
                    }
                    @if (ct.type == 'Airport') {
                    <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                    }
                    @if (ct.type == 'MultiCity') {
                    <mat-icon>location_city</mat-icon>
                    }
                    @if (ct.type == 'Region') {
                    <mat-icon>public</mat-icon>
                    }
                    @if (ct.type == 'Neighborhood') {
                    <mat-icon>near_me</mat-icon>
                    }
                    @if (ct.type == 'State') {
                    <mat-icon>location_on</mat-icon>
                    }
                    <span class="font-normal text-base"
                      [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                  </div>
                  <!-- <div class="flex flex-col truncate max-w-full justify-center">
                                                    <span class="font-normal text-base">{{ct.city}}
                                                    </span>
                                                  </div> -->
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[220px] border-r gray-border h-[75px] cursor-pointer"
              [ngClass]="selectedField == 'checkin' ? 'secondary-bg' : ''" (click)="picker2.open()">
              <div class="ml-[7px]">
                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Check
                    In</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="picker2" [min]="minDate" (click)="picker2.open();selectedField = 'checkin'"
                  formControlName="checkin" (ngModelChange)="changeDate($event)">
                <mat-datepicker-toggle matSuffix [for]="picker2" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
            </div>
            <div class="flex flex-col pl-2 justify-center w-[220px] border-r gray-border cursor-pointer"
              [ngClass]="selectedField == 'checkout' ? 'secondary-bg' : ''" (click)="pickerOne.open()">
              <div class="ml-[7px]">
                <mat-label class="items-center gap-1 flex">
                  <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                      alt="date_icon"></span>
                  <span class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Check
                    Out</span>
                </mat-label>
                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]" matInput
                  [matDatepicker]="pickerOne" [min]="outmindate" (click)="pickerOne.open();selectedField = 'checkout'"
                  formControlName="checkout">
                <mat-datepicker-toggle matSuffix [for]="pickerOne" class="hidden"></mat-datepicker-toggle>
                <mat-datepicker #pickerOne></mat-datepicker>
              </div>
            </div>
            <div class="min-w-[300px] pl-4 border-r gray-border cursor-pointer flex items-center relative"
              [ngClass]="selectedField == 'guest' ? 'secondary-bg' : ''" #containerRef>
              <div class="flex flex-col justify-center" #roomAndGuestRef (click)="openGuest()">
                <span class="font-Roboto text-[15px] text-secondary font-normal w-full h-[24px]">Guest</span>
                <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer">
                  {{formGroup.get('room').value}} Room(s), {{formGroup.get('guest').value}}
                  Guest(s)
                </div>
              </div>
              @if (selectedField === 'guest') {
              <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute left-0 round-shadow z-99"
                #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[80px]':'top-[80px]'">
                <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
              </div>
              }
            </div>
            <div class="h-[75px] min-w-[192px] w-full min-h-[75px] justify-end flex items-center">
              <button class="primary-bg rounded-none h-[75px] min-h-[75px] rounded-r-[4.5px] w-full" mat-flat-button
                (click)="detail()">
                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 11 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme11) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden xl:px-10 px-0">
  <div
    class="bg-cover flex flex-col bg-center bg-no-repeat h-[580px] xl:rounded-[30px] rounded-none primary-bg w-full gray-text"
    style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
 background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
      <div class="flex flex-col">
        <div class="flex">
          <h1 class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] flex rounded-xl mt-[-300px]">
    <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup" class="flex flex-col px-4 pt-18 white-bg pb-[18px] rounded-xl shadow-xl">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[28%] max-w-[28%] h-[74px] py-3 px-2 secondary-bg rounded-[4px] cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Destination</span>
            <mat-select class="mt-1 px-2 font-semibold text-xl" formControlName="destination" #destinationSelect
              [compareWith]="compareWith">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                                    <span class="font-normal text-base">{{ct.city}}
                                                    </span>
                                                  </div> -->
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5 cursor-pointer"
            (click)="picker.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Check In</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[100px]" [min]="minDate" (click)="picker.open()"
                [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                (ngModelChange)="changeDate($event)" />
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="flex flex-col w-[25%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5 cursor-pointer"
            (click)="pickerOne.open()">
            <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Check Out</span>
            <div class="flex flex-row">
              <input class="font-semibold text-xl mt-1 max-w-[100px]" [min]="outmindate" (click)="pickerOne.open()"
                [readonly]="true" [matDatepicker]="pickerOne" formControlName="checkout" />
            </div>
            <mat-datepicker #pickerOne></mat-datepicker>
          </div>
          <div class="min-w-[30%] max-w-[30%] secondary-bg rounded-[4px] cursor-pointer flex items-center relative"
            #containerRef>
            <div class="flex flex-col  h-[74px] py-3 px-2" #roomAndGuestRef (click)="openGuest()">
              <span class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">Rooms
                & Guests</span>
              <span class="pl-2 font-semibold text-xl mt-1 cursor-pointer">{{formGroup.get('room').value}}
                Room,
                {{formGroup.get('guest').value}} Guests</span>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute left-0 round-shadow z-99"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[80px]':'top-[80px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-11 pt-[20px] space-x-4">
          <button mat-flat-button class="w-64 min-h-13 rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 12 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme12) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative h-[595px]">
  <div class="absolute top-[-73px] w-full h-[670px] z-10"
    [style]="'background-image: url('+hotelData?.background_image+');background-blend-mode: color !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
  </div>
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
    <div class="flex flex-col h-full items-center justify-center max-h-[11rem] mt-[73px]">
      <div class="flex flex-col">
        <div class="flex">
          <h1
            class="text-center text-[42px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="text-center w-[1000px] z-[99] textNote3">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
    <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col p-5 pt-3 pb-2.5 bg-[#000000bd] rounded-xl shadow-xl theme12-form-field">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <mat-form-field class="min-w-[30%] w-full">
            <mat-label class="text-[15px] text-white font-normal">Destination</mat-label>
            <mat-select class="font-medium text-black py-[16px] text-[15px] pr-1 max-w-[523px]"
              [compareWith]="compareWith" formControlName="destination">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                                      <span class="font-normal text-base">
                                                      {{ct.city}}</span>
                                                    </div> -->
              </mat-option>
              }
            </mat-select>
            <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-full min-w-[18%]">
            <mat-label class="text-[15px] text-white font-normal">Check In</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
              (ngModelChange)="changeDate($event)" />
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker.open()"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-full min-w-[18%]">
            <mat-label class="text-[15px] text-white font-normal">Check Out</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="outmindate" (click)="picker2.open()"
              [readonly]="true" [matDatepicker]="picker2" formControlName="checkout" />
            <mat-datepicker #picker2></mat-datepicker>
            <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" (click)="picker2.open()"></mat-icon>
          </mat-form-field>
          <div class="min-w-[20%] w-full flex items-center relative" #containerRef>
            <div class="flex flex-col w-full h-[80px]" (click)="openGuest()" #roomAndGuestRef>
              <span class="text-[15px] font-normal pb-[4px] text-white leading-5">Rooms &
                Guests</span>
              <span
                class="font-medium text-[15px] cursor-pointer rounded-[9px] border-[1px] py-[1.05rem] bg-white px-4 flex flex-row justify-between"
                [ngClass]="isOpenRoomsGuests ? 'border-[#4f46e5]' :'border-[#737373]'">{{formGroup.get('room').value}}
                Room,
                {{formGroup.get('guest').value}} Guests
                <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
              </span>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[348px] p-[1.6rem] absolute left-0 round-shadow z-99"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[84px]':'top-[86px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
          <div class="flex justify-center items-end pl-1">
            <button mat-flat-button class="w-[70px] min-w-[70px] min-h-[60px] rounded-lg primary-bg text-white"
              (click)="detail()">
              <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 13 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme13) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[560px] primary-bg w-full gray-text" style="border-bottom-left-radius: 100% 250px;
        border-bottom-right-radius: 100% 250px;
        border-bottom: 14px solid white;
        background-color: #0000007a !important;
        background-image: url('{{hotelData?.background_image}}');
        background-blend-mode: color !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[30rem]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[50px] font-semibold font-[cursive] white-text flex w-full z-[99] tracking-[7px]">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-[30px] font-extralight pt-3 font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="w-[1000px] z-[99] textNote4 leading-[35px]">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-[12px] mt-[-145px]">
    <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
      <form [formGroup]="formGroup"
        class="flex flex-col px-5 pt-3 white-bg rounded-[12px] shadow-xl pb-5 theme12-form-field">
        <div class="flex flex-row w-full space-x-4 mt-3 mb-7">
          <mat-form-field class="min-w-[30%] w-full">
            <mat-label class="text-[16px] unselected-text font-normal">Destination</mat-label>
            <mat-select class="font-medium py-[16px] text-[15px] pr-1 max-w-[523px]" [compareWith]="compareWith"
              formControlName="destination">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                                        <span class="font-normal text-base">
                                                        {{ct.city}}</span>
                                                      </div> -->
              </mat-option>
              }
            </mat-select>
            <mat-icon matPrefix svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-full min-w-[20%]">
            <mat-label class="text-[16px] unselected-text font-normal">Check In</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate" (click)="picker.open()"
              [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
              (ngModelChange)="changeDate($event)" />
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon matPrefix svgIcon="feather:calendar" class="icon-size-5 gray-text"
              (click)="picker.open()"></mat-icon>
          </mat-form-field>
          <mat-form-field class="w-full min-w-[20%]">
            <mat-label class="text-[16px] unselected-text font-normal">Check Out</mat-label>
            <input matInput class="font-medium py-[16px] text-[15px]" [min]="outmindate" (click)="picker2.open()"
              [readonly]="true" [matDatepicker]="picker2" formControlName="checkout" />
            <mat-datepicker #picker2></mat-datepicker>
            <mat-icon matPrefix svgIcon="feather:calendar" class="icon-size-5 gray-text"
              (click)="picker2.open()"></mat-icon>
          </mat-form-field>
          <div class="min-w-[25%] w-full flex items-center relative" #containerRef>
            <div class="flex flex-col h-[80px] w-full" (click)="openGuest()" #roomAndGuestRef>
              <span class="text-[16px] font-normal pb-[4px] unselected-text leading-5">Rooms &
                Guests</span>
              <span
                class="font-medium text-[15px] cursor-pointer rounded-[9px] border-[1px] py-[16px] bg-white px-4 flex flex-row gap-3"
                [ngClass]="isOpenRoomsGuests ? 'border-[#4f46e5]' :'border-[#d2d2d2]'">
                <mat-icon svgIcon="feather:user" class="icon-size-5 gray-text"></mat-icon>
                {{formGroup.get('room').value}} Room,
                {{formGroup.get('guest').value}} Guests
              </span>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[348px] p-[1.6rem] absolute right-0 round-shadow z-99"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[84px]':'top-[86px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
        </div>
        <div class="flex flex-row justify-center items-center -mb-[50px] space-x-4">
          <button mat-flat-button class="w-64 min-h-[60px] rounded-full primary-bg" (click)="detail()">
            <span class="white-text font-medium text-2xl">Search</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 14 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme14) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[510px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
 background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[24rem] pt-[70px]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[48px] font-medium white-text w-full z-[99]" style="font-family: sans-serif;">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-[22px] font-normal font-Ibm_Plex_Sans_Devanagari white-text">
          <div class="w-[650px] z-[99] textNote4">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="min-w-[1260px] max-w-[1260px] z-[99] flex mt-[-61px]">
    <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] rounded-t-none white-bg shadow-xl">
      <form [formGroup]="formGroup" class="flex flex-col border-t-2 pt-4 pb-2">
        <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
          <div
            class="flex flex-col min-w-[28%] w-full h-[74px] py-3 px-2 border-[1px] rounded-[10px] gray-border cursor-pointer"
            (click)="destinationSelect.open()">
            <span class="text-base px-1.5 font-medium max-w-max text-secondary">Destination</span>
            <mat-select class="mt-1 px-1.5 font-semibold text-lg" #destinationSelect formControlName="destination"
              [compareWith]="compareWith">
              <mat-select-trigger>
                {{ getCityName() }}
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search placeholderLabel="Search Destination"
                  noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                </ngx-mat-select-search>
              </mat-option>
              @for (ct of destinationList | async; track ct) {
              <mat-option [value]="ct">
                <div class="flex justify-center truncate max-w-full">
                  @if (ct.type == 'City') {
                  <mat-icon>location_on</mat-icon>
                  }
                  @if (ct.type == 'Hotel') {
                  <mat-icon>apartment</mat-icon>
                  }
                  @if (ct.type == 'PointOfInterest') {
                  <mat-icon>explore</mat-icon>
                  }
                  @if (ct.type == 'TrainStation') {
                  <mat-icon>train</mat-icon>
                  }
                  @if (ct.type == 'Airport') {
                  <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                  }
                  @if (ct.type == 'MultiCity') {
                  <mat-icon>location_city</mat-icon>
                  }
                  @if (ct.type == 'Region') {
                  <mat-icon>public</mat-icon>
                  }
                  @if (ct.type == 'Neighborhood') {
                  <mat-icon>near_me</mat-icon>
                  }
                  @if (ct.type == 'State') {
                  <mat-icon>location_on</mat-icon>
                  }
                  <span class="font-normal text-base"
                    [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                </div>
                <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                                          <span class="font-normal text-base">{{ct.city}}
                                                          </span>
                                                        </div> -->
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="flex flex-row border-[1px] rounded-[10px] gray-border min-w-[32%] w-full cursor-pointer">
            <div class="flex flex-col w-1/2 h-[74px] p-3 border-r-[1px] gray-border cursor-pointer"
              (click)="picker.open()">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="font-medium text-secondary">Check In</span>
                <mat-icon svgIcon="mat_outline:date_range" class="gray-text icon-size-5 cursor-pointer"
                  (click)="picker.open()"></mat-icon>
              </div>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1.5 max-w-[100px]" [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                  (ngModelChange)="changeDate($event)" />
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div class="flex flex-col w-1/2 h-[74px] p-3 cursor-pointer" (click)="pickerOne.open()">
              <div
                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                <span class="font-medium text-secondary">Check Out</span>
                <mat-icon svgIcon="mat_outline:date_range" class="gray-text icon-size-5 cursor-pointer"
                  (click)="pickerOne.open()"></mat-icon>
              </div>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1.5 max-w-[100px]" [min]="outmindate" (click)="pickerOne.open()"
                  [readonly]="true" [matDatepicker]="pickerOne" formControlName="checkout" />
              </div>
              <mat-datepicker #pickerOne></mat-datepicker>
            </div>
          </div>
          <div
            class="min-w-[25%] w-full flex items-center border-[1px] rounded-[10px] gray-border cursor-pointer relative"
            #containerRef>
            <div class="flex flex-col h-[74px] p-3 " (click)="openGuest()" #roomAndGuestRef>
              <span class="pr-[10px] max-w-max text-base font-medium text-secondary">Rooms
                & Guests</span>
              <span class="font-semibold text-lg mt-1 cursor-pointer">{{formGroup.get('room').value}}
                Room,
                {{formGroup.get('guest').value}} Guests</span>
            </div>
            @if (selectedField === 'guest') {
            <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute left-0 round-shadow z-99"
              #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[84px]':'top-[86px]'">
              <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
            </div>
            }
          </div>
          <div class="flex flex-row justify-center items-end">
            <button mat-flat-button class="w-[73px] mb-0.5 min-w-[73px] min-h-[73px] rounded-lg primary-bg text-white"
              (click)="detail()">
              <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
}
<!--Theme 15 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme15) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
      <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
        <div class="flex">
          <h1 class="text-[48px] text-center font-semibold white-text w-full z-[99]" style="font-family: sans-serif;">
            {{hotelData?.title}}</h1>
        </div>
        <div class="flex text-[20px] white-text justify-center">
          <div class="w-[900px] z-[99] font-light textNote2 text-center">
            {{hotelData?.description}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
      <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] white-bg shadow-xl"
        [ngClass]="{ 'rounded-tl-none' : isFirstService }">
        <form [formGroup]="formGroup" class="flex flex-col pt-6 pb-2">
          <div class="flex flex-row w-full space-x-3 mt-3 mb-5">
            <div
              class="flex flex-col min-w-[25%] w-full h-[74px] py-3 px-2 border gray-border rounded-xl cursor-pointer"
              (click)="destinationSelect.open()">
              <span class="px-[10px] max-w-max text-[15px] font-normal text-secondary">Destination</span>
              <mat-select class="mt-1 px-2 font-semibold text-lg" formControlName="destination" #destinationSelect
                [compareWith]="compareWith">
                <mat-select-trigger>
                  {{ getCityName() }}
                </mat-select-trigger>
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationList | async; track ct) {
                <mat-option [value]="ct">
                  <div class="flex justify-center truncate max-w-full">
                    @if (ct.type == 'City') {
                    <mat-icon>location_on</mat-icon>
                    }
                    @if (ct.type == 'Hotel') {
                    <mat-icon>apartment</mat-icon>
                    }
                    @if (ct.type == 'PointOfInterest') {
                    <mat-icon>explore</mat-icon>
                    }
                    @if (ct.type == 'TrainStation') {
                    <mat-icon>train</mat-icon>
                    }
                    @if (ct.type == 'Airport') {
                    <mat-icon class="material-symbols-outlined">flights_and_hotels</mat-icon>
                    }
                    @if (ct.type == 'MultiCity') {
                    <mat-icon>location_city</mat-icon>
                    }
                    @if (ct.type == 'Region') {
                    <mat-icon>public</mat-icon>
                    }
                    @if (ct.type == 'Neighborhood') {
                    <mat-icon>near_me</mat-icon>
                    }
                    @if (ct.type == 'State') {
                    <mat-icon>location_on</mat-icon>
                    }
                    <span class="font-normal text-base"
                      [innerHTML]="highlightSearch(ct.city, searchDestinationText)"></span>
                  </div>
                  <!-- <div class="flex flex-col truncate max-w-full h-15 justify-center">
                                                              <span class="font-normal text-base">{{ct.city}}
                                                              </span>
                                                            </div> -->
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col w-full h-[74px] border gray-border rounded-xl px-3 py-2.5 cursor-pointer"
              (click)="picker.open()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Check In</span>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1 max-w-[120px]" [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                  (ngModelChange)="changeDate($event)" />
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div class="flex flex-col w-full h-[74px] border gray-border rounded-xl px-3 py-2.5 cursor-pointer"
              (click)="pickerOne.open()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Check Out</span>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1 max-w-[120px]" [min]="outmindate" (click)="pickerOne.open()"
                  [readonly]="true" [matDatepicker]="pickerOne" formControlName="checkout" />
              </div>
              <mat-datepicker #pickerOne></mat-datepicker>
            </div>
            <div class="min-w-[22%] w-full flex items-center border gray-border rounded-xl cursor-pointer relative"
              #containerRef>
              <div class="flex flex-col w-full h-[74px] py-3 px-2" (click)="openGuest()" #roomAndGuestRef>
                <span class="px-[10px] max-w-max text-[15px] font-normal text-secondary">Rooms
                  & Guests</span>
                <span class="pl-2 font-semibold text-lg mt-1 cursor-pointer">{{formGroup.get('room').value}}
                  Room,
                  {{formGroup.get('guest').value}} Guests</span>
              </div>
              @if (selectedField === 'guest') {
              <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute left-0 round-shadow z-99"
                #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[84px]':'top-[86px]'">
                <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
              </div>
              }
            </div>
            <div class="flex flex-row justify-center items-center">
              <button mat-flat-button class="w-[130px] min-h-18 rounded-xl primary-bg" (click)="detail()">
                <span class="white-text font-medium text-2xl">Search</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
<!--Theme 16 -->
@if (hotelData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme16) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden">
  <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[650px] primary-bg w-full gray-text" style="background-image: url('{{hotelData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
    <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
      <div class="flex flex-col justify-start min-w-[1260px] max-w-[1260px]">
        <h1 class="text-[48px] font-semibold white-text w-full z-[99] uppercase"
          style="font-family: 'Mina'; text-shadow: 2px 2px 4px rgba(0,0,0,0.4);">
          {{hotelData?.title}}
        </h1>
        <div class="w-[900px] z-[99] text-[20px] white-text font-light textNote2"
          style="text-shadow: 1px 1px 3px rgba(0,0,0,0.3);">
          {{hotelData?.description}}
        </div>
      </div>
    </div>
  </div>
  <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex font-['Poppins']">
      <div class="bg-white/40 p-6 w-full backdrop-blur-md rounded-[20px]">
        <form [formGroup]="formGroup" class="flex flex-col">
          <div class="flex flex-row w-full space-x-3">
            <div class="flex flex-col min-w-[30%] max-w-[30%] h-[74px] py-3 px-2 white-bg rounded-2xl cursor-pointer"
              (click)="destinationSelect.open()">
              <span class="px-[10px] max-w-max text-[15px] font-normal text-secondary">Destination</span>
              <mat-select class="mt-1 px-2 font-semibold text-lg" formControlName="destination" #destinationSelect
                [compareWith]="compareWith">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search Destination"
                    noEntriesFoundLabel="'no matching destination found'" formControlName="destinationfilter">
                  </ngx-mat-select-search>
                </mat-option>
                @for (ct of destinationList | async; track ct) {
                <mat-option [value]="ct">
                  <div class="flex flex-col truncate max-w-full h-15 justify-center">
                    <span class="font-normal text-base">{{ct.city}}
                    </span>
                  </div>
                </mat-option>
                }
              </mat-select>
            </div>
            <div class="flex flex-col min-w-[20%] w-[22%] h-[74px] white-bg rounded-2xl px-3 py-2.5 cursor-pointer"
              (click)="picker.open()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Check In</span>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1 max-w-[120px]" [min]="minDate" (click)="picker.open()"
                  [readonly]="true" [matDatepicker]="picker" formControlName="checkin"
                  (ngModelChange)="changeDate($event)" />
              </div>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <div class="flex flex-col min-w-[20%] w-[22%] h-[74px] white-bg rounded-2xl px-3 py-2.5 cursor-pointer"
              (click)="pickerOne.open()">
              <span class="max-w-max text-secondary text-[15px] font-normal">Check Out</span>
              <div class="flex flex-row">
                <input class="font-semibold text-lg mt-1 max-w-[120px]" [min]="outmindate" (click)="pickerOne.open()"
                  [readonly]="true" [matDatepicker]="pickerOne" formControlName="checkout" />
              </div>
              <mat-datepicker #pickerOne></mat-datepicker>
            </div>
            <div class="min-w-[20%] w-full flex items-center white-bg rounded-2xl cursor-pointer relative"
              #containerRef>
              <div class="flex flex-col h-[74px] py-3 px-2 " (click)="openGuest()" #roomAndGuestRef>
                <span class="px-[10px] max-w-max text-[15px] font-normal text-secondary">Rooms
                  & Guests</span>
                <span class="pl-2 font-semibold text-lg mt-1 cursor-pointer">{{formGroup.get('room').value}}
                  Room,
                  {{formGroup.get('guest').value}} Guests</span>
              </div>
              @if (selectedField === 'guest') {
              <div class="bg-white rounded-3xl w-[375px] p-[1.6rem] absolute left-0 round-shadow z-99"
                #roomsAndGuestsDropdown [ngClass]="guestPopAbove?'bottom-[84px]':'top-[86px]'">
                <app-rooms-and-guests [paxData]="{ data: this.formGroup.value, roomdata: this.roomData }"
                  class="text-black" (OnClose)="patchPaxData($event)"></app-rooms-and-guests>
              </div>
              }
            </div>
            <div class="flex flex-row justify-center items-start">
              <button mat-flat-button class="rounded-xl min-h-[74px] primary-bg" (click)="detail()">
                <mat-icon class="text-white invert w-8 h-8" svgIcon="feather:search"></mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
}
}